import { useEffect, useRef } from 'react'

import useSidebarStore from 'src/stores/useSidebarStore'
import useProductMatchParams from './useProductMatchParams'

const useSetDefaultCurrentOpenedProduct = () => {
  const { toggleCurrentOpenedProduct, currentOpenedProduct } = useSidebarStore()
  const routeMatch = useProductMatchParams()
  const product = routeMatch?.params.product

  const isDefaultOpenedRef = useRef(false)

  useEffect(() => {
    if (product && !currentOpenedProduct && !isDefaultOpenedRef.current) {
      toggleCurrentOpenedProduct(product, true)
      isDefaultOpenedRef.current = true
    }
  }, [product, currentOpenedProduct, toggleCurrentOpenedProduct])

  return { isDefaultOpened: isDefaultOpenedRef.current }
}

export default useSetDefaultCurrentOpenedProduct
